import { CSS, type Transform } from '@dnd-kit/utilities';
import type { CSSProperties } from 'react';

interface GetSortableItemStyleInput {
  transform: Transform | null;
  transition?: string;
  isDragging: boolean;
}

/**
 * Shared inline style for sortable list items that don't use `DragOverlay`.
 *
 * - Uses `CSS.Translate.toString` (not `CSS.Transform.toString`) to avoid
 *   scaleX/scaleY distortion when dragging past differently-sized siblings
 *   (e.g., expanded vs. collapsed accordions).
 * - Sets `position: relative` so `zIndex` takes effect, ensuring the dragged
 *   item renders above its siblings.
 */
export function getSortableItemStyle({
  transform,
  transition,
  isDragging,
}: GetSortableItemStyleInput): CSSProperties {
  return {
    transform: CSS.Translate.toString(transform),
    transition,
    position: 'relative',
    zIndex: isDragging ? 1 : 0,
  };
}
